import React from 'react';

export function CallIcon({ name }) {
  const paths = {
    message: <path d="M21 11a8 8 0 0 1-8 8H7l-5 3 2-6a8 8 0 1 1 17-5ZM8 10h8M8 14h5" />,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M7 2v6M17 2v6M3 11h18M8 15h2M14 15h2" /></>,
    video: <><rect x="2" y="5" width="14" height="14" rx="3" /><path d="m16 10 6-4v12l-6-4" /></>,
    mic: <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8" /></>,
    muted: <><path d="M9 5V4a3 3 0 0 1 6 0v7M5 10v2a7 7 0 0 0 12 5M19 10v2M12 19v3M8 22h8M3 3l18 18" /></>,
    volume: <><path d="M11 4L6 8H2v8h4l5 4zM15 8a6 6 0 0 1 0 8M18 5a10 10 0 0 1 0 14" /></>,
    end: <><path d="M3 15l3-2 2 2v4H3zM21 15l-3-2-2 2v4h5zM3 15c2-8 16-8 18 0" /></>,
    shield: <><path d="M12 2l8 3v6c0 5-5 9-8 11-3-2-8-6-8-11V5zM12 7v6M12 17h.01" /></>,
    sparkle: <><path d="M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5zM20 2v4M18 4h4" /></>,
    close: <path d="M6 6l12 12M6 18L18 6" />,
    check: <path d="M5 12l4 4L19 6" />,
  };
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.sparkle}</svg>;
}

export function StageProgress({ stage }) {
  const active = stage === 8 ? 3 : stage - 4;
  return <nav className="session-progress" aria-label="התקדמות השיחה">
    <span className="session-progress-caption">{stage === 3 ? "החיבור שלכם מתחיל כאן" : "בלי לחץ. פשוט תהיו אתם."}</span>
    <ol>{["מתחילים בקול", "קצת מסתורין", "נעים להכיר", "קובעים דייט"].map((label, i) =>
      <li key={label} className={i === active ? 'is-current' : i < active ? 'is-complete' : ''} aria-current={i === active ? 'step' : undefined}>
        <span className="session-step-number">{i < active ? <CallIcon name="check" /> : `0${i + 1}`}</span><span>{label}</span>
      </li>)}</ol>
  </nav>;
}

export function CallDock({ muted, micLocked = false, onMute, volume, onVolume, onEnd, onReport, children }) {
  return <div className="call-dock" role="group" aria-label="פקדי שיחה">
    <div className="call-dock-main">
      <button type="button" className={`dock-button ${muted || micLocked ? 'is-muted' : ''}`} onClick={onMute} disabled={micLocked}
        aria-pressed={muted || micLocked} aria-label={micLocked ? "המיקרופון מושהה בזמן התור של הצד השני" : muted ? "ביטול השתקת המיקרופון" : "השתקת המיקרופון"}>
        <CallIcon name={muted || micLocked ? 'muted' : 'mic'} /><span>{micLocked ? "מקשיבים" : muted ? "ביטול השתקה" : "המיקרופון פעיל"}</span>
      </button>
      <label className="dock-volume"><CallIcon name="volume" /><span>עוצמת קול</span>
        <input aria-label="עוצמת הקול של הצד השני" type="range" min="0" max="1" step="0.05" value={volume} onChange={e => onVolume(Number(e.target.value))} />
      </label>
      {children}
      <span className="dock-spacer" />
      <button type="button" className="dock-button dock-report" onClick={onReport}><CallIcon name="shield" /><span>דיווח</span></button>
      <button type="button" className="dock-button dock-end" onClick={onEnd} aria-label="סיום שיחה"><CallIcon name="end" /><span>יציאה</span></button>
    </div>
  </div>;
}
